export const clearFilters = (filters) => {
    const clearedFilters = filters;
    Object.entries(filters).map(([key, filter]) => {
        return clearedFilters[key] = filter.map(option => ({...option, isSelected : false}));
        
    });
    return clearedFilters;
}